<template lang="html">
  <div class="eb-pt-row-login">
    <div class="col-md-12">
      <div class="inner cover">
        <h4 class="text-center mb-4 mt-4">Forgot Password</h4>
        <form>
          <p>Enter the email that you signed up with and you will receive instructions on how to reset your password.</p>
          <div class="form-group mt-4 mb-4">
            <GfInput             
              type="email"
              initial-field-value="" 
              place-holder="Email"
              :has-error="validation.hasError('email_receive')" 
              :error-text="validation.firstError('email_receive')"            
              @valueChanged="(val) => email_receive = val">
            </GfInput>
          </div>
          <div class="form-group mt-4">
            <div class="row justify-content-md-center">
              <div class="col-md-8 col-md-push-4">
                <button 
                  id="btn-submit" 
                  type="button" 
                  class="btn btn-block btn-driver" 
                  @click="submit_form">Submit</button>
              </div>
            </div>
          </div>
          <br>
        </form>
      </div>
    </div>
    <div class="col-md-12">
      <p class="d-inline pl-5 float-left">
        Try Again?
      </p>
      <p class="d-inline pr-5 float-right">
        <a 
          class="statusLogin primary-link" 
          @click="StatusCheckLogin('login')"
        >
          Log in
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
var Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);
import axios from 'axios';
import qs from 'qs';
import GfInput from '../inc/GfInput.vue';
export default {
  components: { GfInput },

  data(){
    return{
      email_receive: ''
    }
  },
  
  methods:{
    StatusCheckLogin(type){
      this.$emit('StatusCheckLogin', type);
    },
    submit_form(){
      var vm = this;
      this.$validate().then(function(success){
        if(success){
            axios.post('/account/forgot-password',{email: vm.email_receive},{
              headers: {
                'Content-Type': 'application/json',
              }
            }).then(function(success) {
              if (success !== undefined && success.status === 200 && success.data.url && success.data.url.toLowerCase() === "logon") {
                vm.$store.commit('setAlertMsg', "A reset password email has been sent to: " + vm.email_receive);
                vm.$emit('StatusCheckLogin', 'login');
                return;                
              }
              if (success.data.TempData["Status.Css"] && success.data.TempData["Status.Css"].toLowerCase() == "error") {
                vm.$store.commit('setAlertMsg', success.data.TempData["Status.Message"]);
                vm.$emit('StatusCheckLogin', 'login');
                return;
              }
              // do something
            }).catch(function(error) {
              console.log(error);
            });
        }
      })
    }
  },
  validators:{
    email_receive: function(value){
      return Validator.value(value).required().email();
    }
  }
}
</script>

<style lang="css">
</style>
